import React, { useCallback, useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import noImage from "../../assets/images/no_image.jpg";
import * as utils from "../../Utils/comman";

function View(props) {
  const [typeCode, setTypeCode] = useState([]);
  let vendorType = "";
  if (props.currentComp === "distributor") vendorType = "Distributor";
  else if (props.currentComp === "dealer") vendorType = "Dealer";
  else if (props.currentComp === "retailer") vendorType = "Retailer";
  else if (props.currentComp === "key-accounts") vendorType = "Key Accounts";
  else if (props.currentComp === "pro") vendorType = "PRO";

  const { rowData } = props;

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const getTypeCode = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("vendor_type", vendorType);
    utils
      .callAPI("post", `/sales/getTypeCode`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setTypeCode(res);
        } else {
          setTypeCode([]);
        }
      })
      .catch((err) => {
        setTypeCode([]);
      });
  };

  useEffect(() => {
    getTypeCode();
  }, [vendorType]);

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header className="border-0">
          <h4>Godown Details</h4>
          <div className="card-header-action">
            <RB.Button className="btn btn-light" onClick={handleBackClick}>
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <>
            <h6>Contact Details</h6>
            <hr className="hr-lg mt-1" />
          </>
          <RB.Row>
            <RB.Col md={12}>
              <RB.Row className="mb-3">
                {rowData?.contact_person_name && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Contact Person Name
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData?.contact_person_name}
                    </p>
                  </RB.Col>
                )}
                {rowData.contact_mobile_no && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Mobile No
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.contact_mobile_no}
                    </p>
                  </RB.Col>
                )}
              </RB.Row>
            </RB.Col>
          </RB.Row>

          <>
            <h6>Godown</h6>
            <hr className="hr-lg mt-1" />
          </>
          <RB.Row>
            <RB.Col md={12}>
              <RB.Row className="mb-3">
                {rowData?.godown_name && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Godown Name
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData?.godown_name}
                    </p>
                  </RB.Col>
                )}
                {rowData.godown_address && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Address
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.godown_address}
                    </p>
                  </RB.Col>
                )}

                {rowData.godown_pincode && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Pin Code
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.godown_pincode}
                    </p>
                  </RB.Col>
                )}

                {rowData.godown_city && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      City
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.godown_city}
                    </p>
                  </RB.Col>
                )}

                {rowData.godown_state && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      State
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.godown_state}
                    </p>
                  </RB.Col>
                )}
                {rowData.godown_district && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      District
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.godown_district}
                    </p>
                  </RB.Col>
                )}
              </RB.Row>
            </RB.Col>
          </RB.Row>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default View;
